/* eslint-disable */
<template>
  <div id="dash-home">
    <h1>Welcome to the new PlayPosit Dashboard!</h1>
  </div>
</template>

<script>

export default {
  name: 'dash-home',
};
</script>

<style scoped>
#dash-home {
  grid-row: 3/4;
  grid-column: 2/3;
  width: calc(100vw -250px);
  height: 82vh;
  overflow: auto;
  min-width: 475px;
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
}
</style>
